import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, fmtPrice } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const { clear } = useCart();
  const polls = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        setInfo(r.data);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (["expired", "failed"].includes(r.data.payment_status)) { setStatus("error"); return; }
      } catch {
        setStatus("error"); return;
      }
      polls.current += 1;
      if (polls.current > 15) { setStatus("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]); // eslint-disable-line

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-6 py-24 text-center">
      {status === "checking" && (
        <>
          <Loader2 className="h-16 w-16 animate-spin text-blue-600" />
          <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">Validation du paiement...</h1>
          <p className="mt-2 text-slate-500">Merci de patienter quelques instants.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-green-600" data-testid="payment-success-icon" />
          <h1 className="mt-6 font-head text-3xl font-extrabold text-slate-900">Commande confirmée !</h1>
          <p className="mt-2 text-slate-500">Merci pour votre achat chez JC BOUTIK.</p>
          {info?.amount != null && <p className="mt-4 text-lg font-bold text-slate-900">Montant payé : {fmtPrice(info.amount)}</p>}
          <p className="mt-1 text-xs text-slate-400">Un email de confirmation sera envoyé à votre adresse.</p>
          <Link to="/"><Button className="mt-8 rounded-full bg-blue-600 px-8 py-6 text-white hover:bg-blue-700">Retour à la boutique</Button></Link>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <XCircle className="h-16 w-16 text-red-500" />
          <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">
            {status === "timeout" ? "Paiement en cours de vérification" : "Un problème est survenu"}
          </h1>
          <p className="mt-2 text-slate-500">Si vous avez été débité, contactez-nous à contact@jcentreprise.com.</p>
          <Link to="/"><Button variant="outline" className="mt-8 rounded-full px-8">Retour à l'accueil</Button></Link>
        </>
      )}
    </div>
  );
}
